import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { ConfirmationComponent } from './confirmation.component';

@Injectable()
export class ConfirmationDialogService {

    bsModalRef: BsModalRef;

  constructor(private modalService: BsModalService) { }

  public confirm(
    title: string,
    message: string,
    btnOkText: string = 'OK',
    btnCancelText: string = 'Cancel',
    dialogSize: 'sm'|'lg' = 'sm'): Observable<boolean> {

    const initialState = {
        title: title,
        message: message,
        btnOkText: btnOkText,
        btnCancelText: btnCancelText
    };

    this.bsModalRef = this.modalService.show(ConfirmationComponent, 
      Object.assign({initialState}, { class: 'custom-modal' })
      );

    return new Observable<boolean>(this.getConfirmSubscriber());
  }

  private getConfirmSubscriber() {
    return (observer) => {
      const subscription = this.modalService.onHidden.subscribe((reason: string) => {

        if(this.bsModalRef.content.answer == 'accept')
            observer.next(true); 
        else
            observer.next(false);
        
        observer.complete();
      });

      return {
        unsubscribe() {
          subscription.unsubscribe();
        }
      };
    }
  }

}
